(function($) {
    var path_name = window.location.pathname;
    var host_name = window.location.hostname;
    var search_value = window.location.search;
    $( ".gdpr_50400" ).on( "change", function() {
        $( this ).removeClass( "has-error" );
    } );
    $( ".gdpr_50513" ).on( "change", function() {
        $( this ).removeClass( "has-error" );
    } );

    $( "html" ).css( "background-color", "#EBEAE4" );
    $( "body" ).css( "background-color", "#EBEAE4" );

    $( "#mc-embedded-subscribe" ).on( "click", function() {
        $( ".has-error:eq(0)" ).css( "display", "none" );
        $( ".has-error:eq(1)" ).css( "display", "none" );
        $( ".has-error:eq(2)" ).css( "display", "none" );
        
        var isValid = true;

        if( $( "#mce-FNAME" ).val() === "" ) {
            $( ".has-error:eq(0)" ).css( "display", "block" );
            // $( "#mce-FNAME" ).trigger("focus");
            isValid = false;
        }
        if( $( "#mce-LNAME" ).val() === "" ) {
            $( ".has-error:eq(1)" ).css( "display", "block" );
            isValid = false;
        }
        if( $( "#mce-EMAIL" ).val() === "" ) {
            $( ".has-error:eq(2)" ).css( "display", "block" );
            isValid = false;
        }
        if( !$( ".gdpr_50400" )[0].checked ) {
            $( ".gdpr_50400" ).addClass( "has-error" );
            isValid = false;
        }
        if( !$( ".gdpr_50513" )[0].checked ) {
            $( ".gdpr_50513" ).addClass( "has-error" );
            isValid = false;
        }

        var bannerHeight = $( ".happydays-banner" ).height();
        if( isValid ) {
            var dataSerialized = $('#mc-embedded-subscribe-form').serialize();
            $.ajax({
                type: 'POST',
                url: 'https://camdenmarket.us4.list-manage.com/subscribe/post-json?u=78efecf01530132ed95849d8e&id=b074092387&v_id=2897&f_id=00fa59e3f0&c=?',
                data: dataSerialized,
                cache: false,
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                error: (error) => {
                    console.log('Error', error);
                },
                success: (res) => {
                    if( res.result === "error" ) {
                        var resMessage = "* This email has already been used.";
                        $( ".has-error:eq(2)" ).css( "display", "block" ).html("").append( resMessage );
                        $( "#mce-EMAIL" ).trigger( "focus" );
                    } else {
                        window.location.href = window.location.protocol + path_name + "/thank-you" + search_value;
                    }
                }
            });
        } else {
            $(this).css( "background-color", "#F7F5EB" );
            $(this).css( "color", "#302e52" );
        }
    } );

    $( "#mc-embedded-subscribe-tablet" ).on( "click", function() {
        $( ".has-error-tablet:eq(0)" ).css( "display", "none" );
        $( ".has-error-tablet:eq(1)" ).css( "display", "none" );
        $( ".has-error-tablet:eq(2)" ).css( "display", "none" );
        
        var isValid = true;

        if( $( "#mce-FNAME-tablet" ).val() === "" ) {
            $( ".has-error-tablet:eq(0)" ).css( "display", "block" );
            // $( "#mce-FNAME" ).trigger("focus");
            isValid = false;
        }
        if( $( "#mce-LNAME-tablet" ).val() === "" ) {
            $( ".has-error-tablet:eq(1)" ).css( "display", "block" );
            isValid = false;
        }
        if( $( "#mce-EMAIL-tablet" ).val() === "" ) {
            $( ".has-error-tablet:eq(2)" ).css( "display", "block" );
            isValid = false;
        }
        if( !$( "#gdpr_50400-tablet" )[0].checked ) {
            $( "#gdpr_50400-tablet" ).addClass( "has-error" );
            isValid = false;
        }
        if( !$( "#gdpr_50513-tablet" )[0].checked ) {
            $( "#gdpr_50513-tablet" ).addClass( "has-error" );
            isValid = false;
        }

        var bannerHeight = $( ".happydays-banner" ).height();
        if( isValid ) {
            var dataSerialized = $('#mc-embedded-subscribe-form-tablet').serialize();
            $.ajax({
                type: 'POST',
                url: 'https://camdenmarket.us4.list-manage.com/subscribe/post-json?u=78efecf01530132ed95849d8e&id=b074092387&v_id=2897&f_id=00fa59e3f0&c=?',
                data: dataSerialized,
                cache: false,
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                error: (error) => {
                    console.log('Error', error);
                },
                success: (res) => {
                    if( res.result === "error" ) {
                        var resMessage = "* This email has already been used.";
                        $( ".has-error-tablet:eq(2)" ).css( "display", "block" ).html("").append( resMessage );
                        $( "#mce-EMAIL-tablet" ).trigger( "focus" );
                    } else {
                        // Redirect Page
                        window.location.href = window.location.protocol + path_name + "/thank-you" + search_value;
                    }
                }
            });
        } else {
            $(this).css( "background-color", "#F7F5EB" );
            $(this).css( "color", "#302e52" );
        }
    } );
    function setHeightTablet() {
        $( "#tablet-signup-form .second-cols" ).height( $( window ).height() );
        $( "#tablet-signup-form .first-cols" ).height( "0px" );
        $( "html, body" ).attr( "style", "background-color: #213e1d !important;" );
    }
    function setHeight(bannerHeight) {
        $( ".happydays-banner" ).height( bannerHeight );
    }

    if( $('.page-template-template-happydays-thankyou-php').length > 0 ) {
        $( ".sign-up-form" ).css( "display", "none" );
        $( ".thank-you-form" ).css( "display", "block" );
        $( ".thank-you-form-tablet" ).css( "display", "block" );
    }
}(jQuery));
